// Tour step specs — single source of truth for the post-onboarding guided tour on /plans.
//
// Each step points at a DOM target via one or more CSS selectors (first match wins).
// `advance` rules:
//   'button'   — tooltip shows a «Далее» button; no interaction with the target is required
//   'click'    — no «Далее» button; the target itself advances the tour when clicked/navigated
//
// The tour is NOT skippable — there is no «Пропустить». Users must touch every step.

export const TOUR_STEPS = [
    {
        id: 0,
        // First roadmap tile on Level 1 (all roadmaps).
        selectors: ['[data-tour-id="roadmap-card"]'],
        title: 'Это твой учебный план',
        body: 'На триале у тебя открыт Day 1 Биохимии и Иммунологии. Нажми на план, чтобы раскрыть блоки.',
        advance: 'click',
        placement: 'bottom',
    },
    {
        id: 1,
        // First module tile inside a roadmap (Level 2).
        selectors: ['[data-tour-id="module-card"]'],
        title: 'Это блок тем',
        body: 'Внутри блока дни с заданиями. Нажми на первый блок, чтобы увидеть Day 1.',
        advance: 'click',
        placement: 'bottom',
    },
    {
        id: 2,
        // First read-type task inside Day 1 (Level 3).
        selectors: ['[data-tour-id="first-read-task"]'],
        title: 'Это текстовый модуль',
        body: 'Открой теорию, без неё вопросы бьют мимо. Нажми на название модуля, прочти и вернись к плану.',
        advance: 'click',
        placement: 'top',
    },
    {
        id: 3,
        // First mini_quiz / qbank task inside Day 1.
        selectors: ['[data-tour-id="first-quiz-task"]'],
        title: 'Это мини-тест',
        body: '5–10 вопросов после теории. Нажми «Решить» и сразу закрепим прочитанное.',
        advance: 'click',
        placement: 'top',
    },
    {
        id: 4,
        // First gate / final_gate task inside Day 1.
        selectors: ['[data-tour-id="first-gate-task"]'],
        title: 'Это клиническая задача',
        body: 'UWorld-style виньетка, сердце QBank. После модулей и мини-теста ты готов её решать. Нажми «Завершить тур», чтобы закончить.',
        advance: 'button',
        buttonLabel: 'Завершить тур',
        placement: 'top',
    },
];

export const TOUR_TOTAL_STEPS = TOUR_STEPS.length;

// localStorage keys shared between WelcomeModal, PlansPage, OnboardingTour,
// ModuleDetailPage and TestSessionPage.
export const LS_KEYS = {
    pending: 'apex_tour_pending',
    step: 'apex_tour_step',
    done: 'apex_tour_done',
};
